import * as _4 from 'lodash4';

export interface ILocationGroup {
  id: string;
  locations: any[];
}

export interface IPathItem {
  location_group: string;
}

export class PathDetailChildrenController {
  private children: object;
  private locationGroups: ILocationGroup[];

  constructor(private pathDetailLocationService: any) {}

  $onInit(): void {
    if (_4.isUndefined(this.locationGroups)) {
      return;
    }
    this.update();
  }

  $onChanges(changes: ng.IChangesObject): void {
    if (_4.isEmpty(changes)) {
      return;
    }
    this.update();
  }

  update() {
    this.formatLocationGroups();
  }

  isLocationAvailable(child: IPathItem): boolean {
    return !_4.isUndefined(child.location_group);
  }

  getChildLocations(locationGroupID: string): any[] {
    return _4.result(
      _4.find(this.locationGroups, {
        id: locationGroupID
      }),
      'locations'
    );
  }

  formatLocationGroups(): void {
    _4.forEach(this.locationGroups, (locationGroup: ILocationGroup) => {
      locationGroup.locations = this.pathDetailLocationService.getFormattedLocations(locationGroup.locations);
    });
  }
}

export class PathDetailChildrenComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-todos/src/components/my_path_task_detail_child/my_path_task_detail_child.html';
  public controller: any = PathDetailChildrenController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    children: '<',
    locationGroups: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/my_path_task_detail_child/my_path_task_detail_child_controller.ts